import { call, put, takeLatest } from "redux-saga/effects";
import { specialPrizesPresetsAPI } from "../api/api";
import { SpecialPrizesPresetsActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() => specialPrizesPresetsAPI.getSubsidiaries());

        yield put({
            type: SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}
